module.exports = __webpack_public_path__ + "img/chicago.0c19dbaa.jpg";